<div class="of-page">

  <!-- Top offer bar -->
  <div class="of-topbar">
    Early-bird pricing on 11+ mock exams ends soon.
    <a href="#offers-list" (click)="scrollToOffers($event)">See offers</a>
  </div>

  <!-- Hero -->
  <section class="of-hero">
    <div class="of-hero-inner">
      <div class="of-hero-copy">
        <span class="of-live">
          <span class="of-live-dot"></span>
          <span *ngIf="!loading && allOffers.length">{{ allOffers.length }} offers open right now</span>
          <span *ngIf="loading || !allOffers.length">Offers open right now</span>
        </span>
        <h1 class="of-hero-title">Learn More. Achieve More. Spend Less This Term!</h1>
        <p class="of-hero-text">
Expert Tuition | Courses | Mock Exams | Learning Resources
<br>
        </p>
        <div class="of-hero-actions">
          <button type="button" class="of-btn of-btn-gold" (click)="scrollToOffers()">
            <i class="ti ti-discount-2"></i> Browse all offers
          </button>
          <button type="button" class="of-btn of-btn-ghost" (click)="bookSlot()">
            <i class="ti ti-calendar-event"></i> Book a free workshop
          </button>
        </div>
      </div>

      <!-- Featured ticket -->
      <article class="of-ticket" aria-label="Latest offer">
        <div class="of-ticket-media">
          <img [src]="heroImage()"
               [alt]="featuredOffer?.title || 'Latest offer'"
               (error)="onImgError($event, featuredOffer ? featuredOffer.category : 'Sehyog offers')" />
          <span class="of-ticket-flag"><i class="ti ti-sparkles"></i> Latest offer</span>
        </div>
        <div class="of-perf"></div>
        <div class="of-ticket-body">
          <ng-container *ngIf="featuredOffer; else ticketLoading">
            <span class="of-tag">{{ featuredOffer.category || 'Offer' }}</span>
            <h2 class="of-ticket-title">{{ featuredOffer.title || 'View offer' }}</h2>
            <p class="of-ticket-desc" *ngIf="featuredOffer.description">{{ featuredOffer.description }}</p>
            <button type="button" class="of-btn of-btn-gold of-btn-block" (click)="onImageClick(featuredOffer)">
              Claim offer
            </button>
          </ng-container>
          <ng-template #ticketLoading>
            <span class="of-tag">{{ error ? 'Offers' : 'Loading' }}</span>
            <h2 class="of-ticket-title">{{ error ? 'See all our courses' : 'Finding this week’s best offer…' }}</h2>
            <button type="button" class="of-btn of-btn-gold of-btn-block" (click)="openQuestionBank()" *ngIf="error">
              View courses
            </button>
          </ng-template>
        </div>
      </article>
    </div>
  </section>

  <!-- Offers -->
  <section class="of-section" id="offers-list">
    <div class="of-head">
      <h2 class="of-head-title">All offers</h2>
      <p class="of-head-text" *ngIf="!loading && !error">{{ resultText }}</p>
      <p class="of-head-text" *ngIf="loading">Filter by course or exam to find yours.</p>
    </div>

    <!-- Category chips -->
    <div class="of-filter" *ngIf="!loading && !error && allOffers.length">
      <div class="of-chips" #chipsEl role="tablist" aria-label="Offer categories">
        <span class="of-chip-spacer"></span>
        <button type="button"
                *ngFor="let c of categories"
                class="of-chip"
                role="tab"
                [class.is-active]="activeCategory === c"
                [attr.aria-selected]="activeCategory === c"
                (click)="setCategory(c, $event)">
          {{ categoryLabel(c) }}
          <span class="of-chip-count">{{ categoryCounts[c] || 0 }}</span>
        </button>
        <span class="of-chip-spacer"></span>
      </div>
    </div>

    <!-- Loading skeleton -->
    <div class="of-grid" *ngIf="loading">
      <div class="of-skel" *ngFor="let s of skeletons">
        <div class="of-skel-media of-shimmer"></div>
        <div class="of-skel-line of-skel-w40 of-shimmer"></div>
        <div class="of-skel-line of-skel-w80 of-shimmer"></div>
        <div class="of-skel-line of-skel-btn of-shimmer"></div>
      </div>
    </div>

    <!-- Error -->
    <div class="of-state" *ngIf="!loading && error">
      <i class="ti ti-wifi-off"></i>
      <h3 class="of-state-title">Offers couldn’t be loaded</h3>
      <p class="of-state-text">{{ error }}</p>
      <button type="button" class="of-btn of-btn-soft" (click)="loadOffers()">
        <i class="ti ti-refresh"></i> Try again
      </button>
    </div>

    <!-- Grid -->
    <div class="of-grid" *ngIf="!loading && !error && filteredOffers.length">
      <article class="of-card" *ngFor="let o of filteredOffers; trackBy: trackByOffer">
        <div class="of-card-media">
          <img [src]="imageSrc(o)"
               [alt]="o.title || 'Offer'"
               loading="lazy"
               (error)="onImgError($event, o.category)" />
        </div>
        <div class="of-card-body">
          <span class="of-tag" *ngIf="o.category">{{ o.category }}</span>
          <h3 class="of-card-title">{{ o.title || 'View offer' }}</h3>
          <p class="of-card-desc" *ngIf="o.description">{{ o.description }}</p>
          <div class="of-card-foot">
            <button type="button" class="of-btn of-btn-gold of-card-btn" (click)="onImageClick(o)">
              Claim offer <i class="ti ti-chevron-right"></i>
            </button>
          </div>
        </div>
      </article>
    </div>

    <!-- Empty -->
    <div class="of-state" *ngIf="!loading && !error && !filteredOffers.length">
      <i class="ti ti-ticket-off"></i>
      <h3 class="of-state-title">No offers in this category yet</h3>
      <p class="of-state-text">New offers are added every week. See what’s available across all courses for now.</p>
      <button type="button" class="of-btn of-btn-soft" (click)="setCategory('all')" *ngIf="activeCategory !== 'all'">
        Show all offers
      </button>
    </div>

    <!-- Help strip -->
    <div class="of-help">
      <div>
        <h3 class="of-help-title">Not sure which offer fits?</h3>
        <p class="of-help-text">Tell us your child’s year group and target exam, and we’ll point you to the right course.</p>
      </div>
      <button type="button" class="of-btn of-btn-soft of-help-btn" (click)="openQuestionBank()">
        <i class="ti ti-message-circle"></i> Ask our team
      </button>
    </div>
  </section>

</div>
